import React, { SyntheticEvent, useState } from 'react';
import { observer } from 'mobx-react';
import Tabs from '@mui/material/Tabs/Tabs';
import Tab from '@mui/material/Tab/Tab';
import Box from '@mui/material/Box/Box';
import Paper from '@mui/material/Paper/Paper';
import AdminUsersTab from './AdminUsersTab';
import AdminWikiEntriesTab from './AdminWikiEntriesTab';

type AdminTabKey = 'users' | 'wiki';

const TABS: { label: string; value: AdminTabKey }[] = [
  { label: 'Users', value: 'users' },
  { label: 'Wiki entries', value: 'wiki' },
];

const AdminPage: React.FC = observer(() => {
  const [activeTab, setActiveTab] = useState<AdminTabKey>('users');

  const handleTabChange = (_event: SyntheticEvent, newValue: AdminTabKey) => {
    setActiveTab(newValue);
  };

  const renderCurrentTab = () => {
    switch (activeTab) {
      case 'wiki':
        return <AdminWikiEntriesTab />;
      case 'users':
      default:
        return <AdminUsersTab />;
    }
  };

  return (
    <Box sx={{ flex: '1 1 auto', width: '100%', px: 4, py: 3 }}>
      <Paper elevation={1} sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 900, p: 2 }}>
        <Tabs value={activeTab} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: 'divider' }}>
          {TABS.map((tab) => (
            <Tab key={tab.value} label={tab.label} value={tab.value} />
          ))}
        </Tabs>
        <Box sx={{ flex: 1, py: 3, overflow: 'auto' }}>{renderCurrentTab()}</Box>
      </Paper>
    </Box>
  );
});

export default AdminPage;
